import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Center, Flex, Spinner, Box } from '@chakra-ui/react';
import { HomePage } from './components/homepage/homepage';

export default function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 1000);
    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    return (
      <Box>
        <Center minH="100vh">
          <Spinner size="xl" color="#A67C52" speed="1.0s" borderWidth="10px" />
        </Center>
      </Box>
    );
  }

  return (
    <Flex minH="100vh" direction="column">
      <Box as="main" flex="1">
        <Router>
          <Routes>
            <Route path="/" element={<HomePage />} />
          </Routes>
        </Router>
      </Box>
    </Flex>
  );
}
